'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var myDocumentsComponent = exports.myDocumentsComponent = {
    template: require('./my-documents.html'),
    controllerAs: 'vm',
    controller: ["config", "common", "authService", "$stateParams", "gettextCatalog", "Analytics", function myDocumentsController(config, common, authService, $stateParams, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$stateParams = $stateParams;
        vm.getUrlReportNarcotics = getUrlReportNarcotics;
        vm.getUrlReportPurchaseProposals = getUrlReportPurchaseProposals;

        function init() {
            common.setTitle(gettextCatalog.getString('_myDocuments.myDocuments'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/myDocuments', gettextCatalog.getString('_myDocuments.myDocuments'));
        }

        function getUrlReportNarcotics() {
            return config.webApiBaseUrl + 'report/narcoticsReminder?lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken;
        }

        function getUrlReportPurchaseProposals() {
            return config.webApiBaseUrl + 'report/purchaseProposals?lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/my-documents.js
// module id = 848
// module chunks = 0